import system from './modules/system/index.js'
import root from './modules/root/index.js'
import creditos from './modules/creditos/index.js'
import dashboard from './modules/dashboard/index.js'
import mailing from './modules/mailing/index.js'
import mensagens from './modules/mensagens/index.js'
import torpedos from './modules/torpedos/index.js'
import usuario from './modules/usuario/index.js'
import protaxi from './modules/protaxi/index.js'
import push from './modules/push/index.js'
import pxtalk from './modules/pxtalk/index.js'
import zendesk from './modules/zendesk/index.js'

import keepAlive from './keepAlive'

export default {
	modules: {
		system,root,creditos,dashboard,mailing,mensagens,torpedos,usuario,protaxi,push,pxtalk,zendesk
    },
    plugins: [keepAlive]
}



// WEBPACK FOOTER //
// ./src/store/index.js